import React from 'react';
import styled, { withTheme } from 'styled-components';
import { Screen } from '../components';
import { MarketCap } from '../screens';

const Content = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  background: linear-gradient(45deg, #1b2230 0, #559bdc 100%);
  color: #fff;
  align-items: center;
  justify-content: center;
`;

const Perspective = styled.div`
  perspective: 3000px;
`;

const Preview = styled.div`
  position: absolute;
  top: -333.5px;
  right: 0;
  bottom: 0;
  left: -187.5px;
  width: 375px;
  height: 667px;
  box-shadow: -1px 1px 1px #222, -2px 2px 1px #111, -3px 3px 1px #000;
  transform: rotateX(40deg) rotateY(0) rotateZ(-40deg) scale(0.7, 0.7);
  @media (min-width: 576px) {
    transform: rotateX(40deg) rotateY(0) rotateZ(-40deg) scale(1.4, 1.4);
  }
`;

const Shadow = styled.div`
  position: absolute;
  top: -233.5px;
  right: 0;
  bottom: 0;
  left: -187.5px;
  width: 375px;
  height: 667px;
  filter: blur(35px);
  transform: rotateX(40deg) rotateY(0) rotateZ(-40deg) scale(0.7, 0.7);
  @media (min-width: 576px) {
    transform: rotateX(40deg) rotateY(0) rotateZ(-40deg) scale(1.4, 1.4);
  }
  background: rgba(0, 0, 0, 0.5);
`;

const ComingSoon = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 8px;
  background: ${props => props.theme.bg};
  @media (min-width: 576px) {
    right: 20px;
    top: 100px;
    padding: 20px;
  }
`;

const Title = styled.div`
  color: ${props => props.theme.botBar.active};
  padding-bottom: 10px;
  text-align: right;
`;

const SubTitle = styled.div`
  color: ${props => props.theme.botBar.icon};
  font-size: 13px;
`;

const Splash = ({ theme }) => (
  <Screen theme={theme} centered>
    <Content>
      <Perspective>
        <Shadow />
        <Preview>
          <MarketCap />
        </Preview>
      </Perspective>
      <ComingSoon>
        <Title>Coinmend</Title>
        <SubTitle>Portfolio Manager - Coming Soon.</SubTitle>
      </ComingSoon>
    </Content>
  </Screen>
);

export default withTheme(Splash);



// WEBPACK FOOTER //
// ./src/screens/Splash.js